<template>
  <div>
    <div id="Chart7" style="width: 100%; height: 250px"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props:{
    chart7_data_x:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_y:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_y2:{
      type:Array,
      default(){
        return []
      }
    },
    chart7_data_y3:{
      type:Array,
      default(){
        return []
      }
    },
  },
  methods: {
    myEcharts7() {
      var myChart7 = this.$echarts.init(document.getElementById("Chart7"));
      //配置图表
      var option7 = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
         formatter: function (data) {
            var text = data[0].name + '<br/>', val;
            for(var i =0; i<data.length; i++){
              let _a = data[i].value || '--'
              if(data[i].value){
                text += data[i].marker + data[i].seriesName  + ': '+ _a+'亿<br/>';
              }else{
                text += data[i].marker + data[i].seriesName  + ': '+ _a+'<br/>';
              } 
            }
            return text;
          }, 
        },
        grid: {
          containLabel: true,
          left: 10,
          right: 10,
          bottom: 20,
          top: 20,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.chart7_data_x,
          offset: 20,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            interval: function (index, string) {
              if (string == "09:30") {
                return true;
              } else if (string == "10:30") {
                return true;
              } else if (string == "11:30") {
                return true;
              } else if (string == "14:00") {
                return true;
              } else if (string == "15:00") {
                return true;
              } else {
                return false;
              }
            },
            formatter: function (value) {
              if (value == "09:30") {
                return `{a|${value}}`;
              } else {
                return `{b|${value}}`;
              }
            },
            rich: {
              a: {
                width: 66,
                align: "right",
              },
              b: {
                width: 66,
                align: "left",
              },
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: function (value) {
                return value <= 0 ? "green" : "red";
              },
            },
          },
        },
        series: [
          {
            name: "港股通(沪)",
            type: "line",
            // stack: "Total",
            smooth: true,
            // symbol: "none",
            symbol: "circle",
            showSymbol: false,
            color: "#fcad2a",
            data: this.chart7_data_y,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(252,173,42,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(252,173,42,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "港股通(深)",
            type: "line",
            // stack: "Total",
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            color: "#539cff",
            data: this.chart7_data_y2,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(83,156,255,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(83,156,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
          {
            name: "南向资金",
            type: "line",
            // stack: "Total",
            smooth: true,
            symbol: "circle",
            showSymbol: false,
            color: "#ffdea8",
            data: this.chart7_data_y3,
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,222,168,.24)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(255,222,168,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
              origin: "start",
            },
          },
        ],
      };
      myChart7.setOption(option7);
    },
  },
  mounted() {
    // this.myEcharts7();
  },
};
</script>

<style scoped>
</style>